import React from "react";
import { Box, Card, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./cisoDashboard.module.scss";

const anomalyData = Array.from({ length: 30 }, (_, i) => ({
  day: i + 1,
  high: 98 + Math.random() * 1,
  medium: 18 + Math.random() * 2,
  low: 8 + Math.random() * 1.5,
}));

export const AnomalyDetectionConfidence = () => {
  return (
    <Card
      className={`${styles.card} ${styles.chartCard}`}
      sx={{ borderRadius: 2 }}
      variant="outlined"
      elevation={0}
    >
      <Box className={styles.sectionTitleRow}>
        <Typography fontWeight={700}>Anomaly Detection Confidence</Typography>
        <Typography variant="body2" color="text.secondary">
          AI Model v2.3
        </Typography>
      </Box>
      <Box height={260}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={anomalyData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="day" tick={{ fontSize: 12 }} />
            <YAxis domain={[0, 110]} tick={{ fontSize: 12 }} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="high"
              stroke="#00b0df"
              strokeWidth={3}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="medium"
              stroke="#f59e0b"
              strokeWidth={3}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="low"
              stroke="#ef4444"
              strokeWidth={3}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default AnomalyDetectionConfidence;
